// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"748":"b3c49460","903":"8f793bb8"}[chunkId] + ".chunk.css";
};